import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useState, useEffect } from "react";

export const ImpersonationBanner = () => {
  const [isImpersonating, setIsImpersonating] = useState(false);
  const [impersonatedUser, setImpersonatedUser] = useState<any>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const checkImpersonation = () => {
      const impersonating = sessionStorage.getItem('impersonating') === 'true';
      const userStr = sessionStorage.getItem('impersonated_user');
      
      setIsImpersonating(impersonating);
      if (userStr) {
        try {
          setImpersonatedUser(JSON.parse(userStr));
        } catch (e) {
          console.error('Error parsing impersonated user:', e);
        }
      }
    };

    checkImpersonation();

    // Listen for storage changes
    window.addEventListener('storage', checkImpersonation);
    return () => window.removeEventListener('storage', checkImpersonation);
  }, []);

  const handleStopImpersonating = async () => {
    try {
      const adminSessionStr = sessionStorage.getItem('admin_session');
      if (!adminSessionStr) {
        toast.error('Admin session not found');
        return;
      }

      const adminSession = JSON.parse(adminSessionStr);
      
      await supabase.auth.setSession({
        access_token: adminSession.access_token,
        refresh_token: adminSession.refresh_token
      });

      sessionStorage.removeItem('impersonating');
      sessionStorage.removeItem('impersonated_user');
      sessionStorage.removeItem('admin_session');

      toast.success('Impersonation ended');
      navigate('/admin/users');
      window.location.reload();
    } catch (error) {
      console.error('Error stopping impersonation:', error);
      toast.error('Failed to stop impersonation');
    }
  };

  if (!isImpersonating || !impersonatedUser) return null;

  return (
    <div className="bg-yellow-500 text-black py-3 px-4 flex items-center justify-between shadow-lg">
      <div className="flex items-center gap-3">
        <AlertTriangle className="h-5 w-5" />
        <div>
          <span className="font-semibold text-sm">
            Viewing as: {impersonatedUser.full_name} ({impersonatedUser.email})
          </span>
          {impersonatedUser.company_name && (
            <span className="ml-2 text-sm opacity-90">
              • {impersonatedUser.company_name}
            </span>
          )}
        </div>
      </div>
      <Button onClick={handleStopImpersonating} variant="secondary" size="sm">
        Exit Impersonation
      </Button>
    </div>
  );
};
